import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
class ListGalleryScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { galleries: [] };
  }
  componentDidMount() {
    this.fetchGalleries();
  }

  fetchGalleries = async () => {
    const data = await API(this, "get", URL_PATH.listGallery);
    // const response = await window.axios.get(URL_PATH.listGallery);
    this.setState({ galleries: data });
  };
  deleteGallery = async (id) => {
    const data = await API(this, "delete", URL_PATH.deleteGallery(id));
    // const response = await window.axios.get(URL_PATH.listGallery);
    // this.setState({ galleries: data });
    this.fetchGalleries();
    window.Alert("Gallery deleted");
  };
  render() {
    return (
      <div className="container">
        <h1>Galleries</h1>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.state.galleries.map((gallery) => (
              <tr key={gallery.id}>
                <td>{gallery.id}</td>
                <td>{gallery.title}</td>
                <td>{gallery.created_at}</td>
                <td>{gallery.updated_at}</td>
                <td>
                  <Link
                    to={routes.admin.gallery.show(gallery.id)}
                    className="btn btn-primary m-1"
                  >
                    Show
                  </Link>
                  <Link
                    to={routes.admin.gallery.update(gallery.id, gallery.name)}
                    className="btn btn-primary m-1"
                  >
                    Edit
                  </Link>
                  <button
                    // to={routes.admin.gallery.delete(
                    //     gallery.id // <-- This is the line that needs to be changed
                    // )}
                    onClick={() =>
                      window.Alert(
                        {
                          title: "delete",
                          text: "are you sure you want to delete this Gallery",
                          showCancelButton: true,
                        },
                        () => {
                          this.deleteGallery(gallery.id);
                        }
                      )
                    }
                    className="btn btn-danger m-1"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default redux(ListGalleryScreen);
